// @core/api/endpoints/authn/send_verification_email.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendVerificationEmailRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Send email verification link
 * Sends a verification email to the specified address containing a link to confirm ownership. The verification token has a limited validity period.
 */
export async function SendVerificationEmail(
  data: SendVerificationEmailRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/email/verification/send`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
